export interface DeviceState {
  isMobileBySensors: boolean;
  isDesktop: boolean;
  desktopOS: DesktopOS | undefined;
  isWindowsDesktop: boolean;
  isLinuxOrUnixDesktop: boolean;

  isMobile: boolean;
  mobileOS: MobileOS | undefined;
  isAndroidDevice: boolean;
  isAppleDevice: boolean;
  isUnknownMobileDevice: boolean;

  browser: Browser | undefined;

  isTablet: boolean;
  initialScreenOrientation: string;
}

export enum MobileOS {
  Android = 'android',
  iOS = 'ios',
  Unknown = 'unknown',
  WindowsPhone = 'Windows Phone',
  Windows = "Windows",
  MacOS = "MacOS",
  Linux = "Linux",
  ChromeOS = "ChromeOS",
}

export enum DesktopOS {
  Linux = 'linux',
  MacOS = 'mac_os',
  Unix = 'unix',
  Unknown = 'unknown',
  Windows = 'windows',
}

export enum Browser {
  Chrome = 'chrome',
  Firefox = 'firefox',
  Safari = 'safari',
  Mi = 'mi',
  Unknown = 'unknown',
  Edge = "Edge",
  Opera = "Opera",
  InternetExplorer = "InternetExplorer",
  Samsung = "Samsung",
}

export type DeviceOS = DesktopOS | MobileOS;
